import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("wm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "Invalid").join(", ");
  return e?.message || "Terjadi kesalahan";
}

export function rupiah(v) {
  return new Intl.NumberFormat("id-ID", {
    style: "currency", currency: "IDR", maximumFractionDigits: 0,
  }).format(v || 0);
}

export function guestToken() {
  let t = localStorage.getItem("wm_guest");
  if (!t) {
    const bytes = new Uint8Array(36);
    crypto.getRandomValues(bytes);
    t = btoa(String.fromCharCode(...bytes)).replace(/[+/=]/g, "").slice(0, 40);
    localStorage.setItem("wm_guest", t);
  }
  return t;
}
